module.exports = __webpack_public_path__ + "static/media/mmume_08.2746b946.png";